'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dPersons$0024package$0024$002dHouse$00242 from "./samples.-Persons$package$-House$2.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$19$$anon$27(evaluator$31) {
  this.Lx = null;
  this.Lx = evaluator$31;
}
export { $c_Lsamples_Persons$package$$anon$19$$anon$27 as $c_Lsamples_Persons$package$$anon$19$$anon$27 };
$p = $c_Lsamples_Persons$package$$anon$19$$anon$27.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$19$$anon$27;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$19$$anon$27() {
}
export { $h_Lsamples_Persons$package$$anon$19$$anon$27 as $h_Lsamples_Persons$package$$anon$19$$anon$27 };
$h_Lsamples_Persons$package$$anon$19$$anon$27.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.Lx.h();
  return ((v instanceof $j_samples$002e$002dPersons$0024package$0024$002dHouse$00242.$c_Lsamples_Persons$package$House$2) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$19$$anon$27 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$19$$anon$27, "samples.Persons$package$$anon$19$$anon$27", ({
  pH: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$19$$anon$27 as $d_Lsamples_Persons$package$$anon$19$$anon$27 };
